import script from "./Studio.vue?vue&type=script&setup=true&lang=js"
export * from "./Studio.vue?vue&type=script&setup=true&lang=js"

import "./Studio.vue?vue&type=style&index=0&id=e43f193e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e43f193e"]])

export default __exports__